export var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=selectURI.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/http/selectURI.js
// module id = ./node_modules/@apollo/client/link/http/selectURI.js
// module chunks = 54 55